import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { ArrowRight, BellRing, ParkingSquare } from 'lucide-react';
import { t, getLocale } from '@/i18n';

// Client's own number (Jeseník holding parking), shown as an estimate.
const PARKING_COST_PER_MONTH = 200000;

const Tile = ({ value, label, className }) => (
  <div className={cn('rounded-xl px-3 py-2', className)}>
    <div className="text-2xl font-bold tabular-nums">{value}</div>
    <div className="text-xs">{label}</div>
  </div>
);

export const ArrivalsSummary = ({ counts, total }) => {
  const navigate = useNavigate();
  const informed = counts.confirmed + counts['en-route'] + counts['on-site'];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <Card className="p-5 lg:col-span-2 border-l-4 border-l-red-500">
        <div className="flex items-start justify-between gap-3 flex-wrap">
          <div>
            <div className="text-sm font-semibold">{t('dash.arrivals.title')}</div>
            <div className="text-xs text-muted-foreground flex items-center gap-1 mt-0.5">
              <BellRing className="h-3 w-3" /> {t('dash.arrivals.urgency')}
            </div>
          </div>
          <Button size="sm" className="gap-1" onClick={() => navigate('/kamiony')}>
            {t('dash.arrivals.open')} <ArrowRight className="h-3.5 w-3.5" />
          </Button>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-4">
          <Tile value={counts['no-info']} label={t('arrivals.state.no-info')} className="bg-red-50 text-red-700 ring-1 ring-red-200" />
          <Tile value={counts['no-power']} label={t('arrivals.state.no-power')} className="bg-orange-50 text-orange-700" />
          <Tile value={informed} label={t('dash.arrivals.informed')} className="bg-blue-50 text-blue-700" />
          <Tile value={`${counts.loaded}/${total}`} label={t('arrivals.state.loaded')} className="bg-muted text-foreground" />
        </div>
      </Card>

      <Card className="p-5">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <ParkingSquare className="h-4 w-4 text-muted-foreground" /> {t('dash.parking.title')}
        </div>
        <div className="text-2xl font-bold mt-3 tabular-nums">
          ≈ {PARKING_COST_PER_MONTH.toLocaleString(getLocale())} Kč
          <span className="text-sm font-medium text-muted-foreground"> / {t('dash.parking.month')}</span>
        </div>
        <div className="text-xs text-muted-foreground mt-1">{t('dash.parking.source')}</div>
        <div className="text-xs mt-3">{t('dash.parking.goal')}</div>
      </Card>
    </div>
  );
};
